import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RouterModule } from '@angular/router';
import { ModalHostComponent } from './components/modal-host/modal-host.component';
import { EllipsisPipe } from './pipes/ellipsis-pipe';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { DashboardCardComponent } from './components/dashboard-card/dashboard-card.component';
import { DetailContainerComponent } from './components/detail-container/detail-container.component';
import { PanelModule } from 'primeng/panel';
import { CardModule } from 'primeng/card';
import { DropdownModule } from 'primeng/dropdown';


@NgModule({
  declarations: [
    ModalHostComponent,
    EllipsisPipe,
    DashboardCardComponent,
    DetailContainerComponent

  ],
  imports: [
    ReactiveFormsModule,
    FontAwesomeModule,
    TableModule,
    InputTextModule,
    RouterModule,
    CommonModule,
    PanelModule,
    CardModule,
    DropdownModule
  ],
  exports: [
    EllipsisPipe, DashboardCardComponent, DetailContainerComponent, PanelModule, CardModule, DropdownModule
  ]
})
export class CommonsModule { }
